import keyMirror from 'keymirror';

export default keyMirror({
  TOGGLE: null,
  CLOSE: null,
});
